import { NavItemType, OverrideIcon } from 'types';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';

import {
    calendarItem,
    couponsItem,
    customerItem,
    employeeItem,
    formBuilderItem,
    insightsItem,
    locationItem,
    organizationItem,
    reportsItem,
    serviceItem,
    preferencesItem,
    widgetItem,
    productItem,
    siteBuilderItem,
    reviewManagementItem,
    serviceCategoriesItem,
    loyaltyProgramItem,
    businessProfileCardItem
} from './allSettings';

// ==============================|| MENU ITEMS ||============================== //

export interface MenuProps {
    id: string;
    title?: React.ReactNode | string;
    type: string;
    icon?: OverrideIcon;
    url?: string;
    children: {
        id: string;
        role_subject?: string;
        role_action?: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}

export type NavItemWithChildren = NavItemType & { children?: MenuProps['children']; role_subject?: string };

const tools: MenuProps = {
    id: 'tools',
    title: 'Tools',
    type: 'group',
    icon: BuildOutlinedIcon,
    children: [customerItem, reportsItem, insightsItem, couponsItem, siteBuilderItem, reviewManagementItem, businessProfileCardItem]
};

const settings: MenuProps = {
    id: 'settings-index',
    title: 'Settings',
    type: 'item',
    url: '/settings',
    icon: WidgetsOutlinedIcon,
    children: [
        preferencesItem,
        employeeItem,
        serviceItem,
        serviceCategoriesItem,
        organizationItem,
        locationItem,
        widgetItem,
        formBuilderItem,
        productItem,
        loyaltyProgramItem
    ]
};

const menuItems: { items: Array<NavItemWithChildren> } = {
    items: [calendarItem, tools, settings]
};

export default menuItems;
